// extracted by mini-css-extract-plugin
export default {"card":"IngredientsCard_card__VSY4x","wrapper":"IngredientsCard_wrapper__QvHKu"};